// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3LJ6r","cell":"ColumnAccessor_cell__rC2rb","firstCellAccent":"ColumnAccessor_firstCellAccent__24H8M"};